<template>
  <div class="video-wrapper">
    <video
      class="video-polaroid"
      autoplay
      muted
      loop
      playsinline
    >
      <source src="@/assets/video-polaroid.mp4" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  name: 'VideoSolo'
}
</script>

<style scoped>
.video-wrapper {
  width: 100vw;
  height: 50vh;
  overflow: hidden;
}

.video-polaroid {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
